const SearchBarIcon = () => {
  return (
    // <a id="iconToPlace" href="#">
      <svg
      
        // style={{ width: "18px", height: "18px" }}
        xmlns="http://www.w3.org/2000/svg"
        fill="#000000"
        viewBox="0 0 256 256"
      >
        <rect width="256" height="256" fill="none"></rect>
        <circle
          cx="116"
          cy="116"
          r="84"
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="24"
        ></circle>
        <line
          x1="175.4"
          y1="175.4"
          x2="224"
          y2="224"
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="24"
        ></line>
      </svg>
    // </a>
  );
};
export default SearchBarIcon;